// src/RightPanel.jsx
import React from "react";
import { useNavigate, Link } from "react-router-dom";
import AppDownloadPromo from "./components/AppDownloadPromo";

const quickIdeas = [
  {
    title: "3-Ingredient Pancakes",
    recipe_uuid: "@caseybrown242/3-ingredient-pancakes-quick-healthy-61ffcaad",
  },
  {
    title: "5-Minute Garlic Noodles",
    recipe_uuid: "@zetsway/5-minute-garlic-noodles-a80290a3",
  },
  {
    title: "2-Ingredient Protein Ice Cream",
    recipe_uuid: "@taylormartinez876/2-ingredient-protein-ice-cream-c7b7a82f",
  },
  {
    title: "Lazy Tortilla Pizza",
    recipe_uuid: "375e413b-0922-4787-9e09-4a01f4c07ed4",
  },
];

export default function RightPanel() {
  const navigate = useNavigate();

  return (
    <aside className="w-full text-base text-gray-700 leading-relaxed">
      <AppDownloadPromo />
      <div className="mb-8">
        <h4 className="font-semibold text-gray-800 mb-3 text-lg">🔥 Trending</h4>
        <ul className="space-y-2 text-sm">
          <li>
            <a
              href="https://www.tiktok.com/tag/foodhacks"
              target="_blank"
              rel="noopener noreferrer"
              className="text-orange-600 hover:underline"
            >
              TikTok Food Hacks →
            </a>
          </li>
        </ul>
      </div>

      <div className="mb-8">
        <h4 className="font-semibold text-gray-800 mb-3 text-lg">⚡ Quick Ideas</h4>
        <ul className="space-y-2 text-sm">
          {quickIdeas.map((idea) => (
            <li
              key={idea.recipe_uuid}
              className="cursor-pointer hover:underline"
              onClick={() => navigate(`/posts/${idea.recipe_uuid}`)}
            >
              {idea.title}
            </li>
          ))}
        </ul>
      </div>

      <div className="mb-8">
        <h4 className="font-semibold text-gray-800 mb-3 text-lg">💡 Pro Tip</h4>
        <p className="text-gray-600 text-[15px]">
          Use a splash of pasta water to make your sauces creamy without cream.
        </p>
      </div>

      <div className="mb-6">
        <h4 className="font-semibold text-gray-800 mb-3 text-lg">
          📆 2026 · 52 Weeks to Become a Chef
        </h4>
        <p className="text-gray-600 text-sm mb-3">
          Level up your cooking skills one focus per week—52 weeks, 52 upgrades.
        </p>
        <Link
          to="posts/@zetsway/2026-52-weeks-to-become-a-chef-8755af78"
          className="inline-flex items-center text-sm font-medium text-orange-600 hover:text-orange-700 hover:underline"
        >
          View the 52-week plan →
        </Link>
      </div>
    </aside>
  );
}